/* BAHARÍ AQUA | Cart integrity for installed pins v3.0.
   Theme-only guard. For unbypassable enforcement use a server-side Cart/Checkout Validation Function. */
(function () {
  'use strict';
  var selector = '#CartDrawer-Checkout, .bahari-cart-checkout, button[name="checkout"], input[name="checkout"]';
  var approved = new WeakSet();
  var pending = false;
  var refreshTimer = null;
  var busy = false;
  var mostRecentIssues = [];
  function cartEndpoint() { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js'; }
  function getCart() {
    return fetch(cartEndpoint(), {credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function (res) { if (!res.ok) throw new Error('Carrito inaccesible'); return res.json(); });
  }
  function positionOf(pin) {
    var props=pin.properties||{};
    var n=Number(props['_Bahari posicion']);
    if (Number.isInteger(n) && n>=1 && n<=8) return n;
    var match=String(props['Ubicación del pin']||'').match(/Posición\s*([1-8])/i);
    return match ? Number(match[1]) : 0;
  }
  function getIssues(cart) {
    var issues=[], items=cart.items||[], spots=new Map();
    items.forEach(function(pin) {
      var props=pin.properties||{};
      if(props['Modalidad del pin']!=='Instalado en sandalias')return;
      var name=pin.product_title||'Pin personalizado';
      var key=props['_Bahari sandalia key'];
      var variant=String(props['_Bahari sandalia variante']||'');
      var unit=Number(props['_Bahari numero de par']);
      var number=positionOf(pin);
      var sandal=items.find(function(item){return item.key===key;});
      if(!key||!variant||!unit){issues.push(name+': faltan las sandalias vinculadas.');}
      else if(!sandal||String(sandal.variant_id)!==variant){issues.push(name+': las sandalias seleccionadas ya no están en el carrito.');}
      else if(Number(sandal.quantity)<unit){issues.push(name+': disminuyó la cantidad del par seleccionado.');}
      if(!number){issues.push(name+': falta la posición de instalación.');return;}
      if(Number(pin.quantity)!==1){issues.push(name+': cada posición debe tener exactamente un pin (cantidad actual '+pin.quantity+').');}
      var spot=key+'::'+unit+'::'+number;
      if(spots.has(spot)){
        issues.push('Posición '+number+' repetida en el mismo par: '+spots.get(spot)+' y '+name+'.');
      }else{spots.set(spot,name);}
    });
    return issues;
  }
  function renderIssues(issues) {
    mostRecentIssues = issues;
    var message = issues.length ? 'Hay pines solicitados para instalación sin las sandalias correspondientes. ' +
      'Corrige el carrito antes de finalizar: ' + issues.join(' ') : '';
    document.querySelectorAll('[data-bahari-cart-pin-warning]').forEach(function (box) {
      if (box.hidden === !issues.length && box.textContent === message) return;
      box.hidden = !issues.length;
      if (box.textContent !== message) box.textContent = message;
    });
    document.querySelectorAll(selector).forEach(function (button) {
      var blocked = issues.length > 0;
      if (button.getAttribute('aria-describedby') !== (blocked ? 'bahari-cart-pin-warning' : null)) {
        if (blocked) { var warning = document.querySelector('[data-bahari-cart-pin-warning]'); if (warning && warning.id) button.setAttribute('aria-describedby', warning.id); }
        else button.removeAttribute('aria-describedby');
      }
      button.classList.toggle('bahari-pin-checkout-needs-review', blocked);
      // Keep click accessible so visitors can see the validation message.
    });
  }
  function showGlobalError(message) {
    var boxes = document.querySelectorAll('[data-bahari-cart-pin-warning]');
    boxes.forEach(function (box) { box.hidden = false; box.textContent = message; });
    if (boxes[0]) boxes[0].scrollIntoView({behavior:'smooth',block:'center'});
    else window.alert(message);
  }
  function validate() { return getCart().then(function (cart) { var issues = getIssues(cart); renderIssues(issues); return issues; }); }
  function schedule() {
    if (refreshTimer !== null) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshTimer = null; validate().catch(function () {}); }, 420);
  }
  function intercept(button, event) {
    if (approved.has(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    validate().then(function (issues) {
      if (issues.length) { showGlobalError('Hay un problema con la instalación de los pines. ' + issues.join(' ') + ' Usa Cambiar posición en el carrito o corrige los productos relacionados.'); return; }
      approved.add(button);
      try { if (button.form && button.form.requestSubmit) button.form.requestSubmit(button); else button.click(); }
      finally { Promise.resolve().then(function () { approved.delete(button); }); }
    }).catch(function () { showGlobalError('No pudimos verificar el carrito. Actualiza la página e inténtalo de nuevo.'); })
      .finally(function () { busy = false; });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(selector);
    if (button) intercept(button, event);
  }, true);
  document.addEventListener('submit', function (event) {
    var button = event.submitter;
    if (button && button.matches && button.matches(selector)) intercept(button, event);
  }, true);
  function ready() {
    if (!document.querySelector(selector)) return;
    schedule();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
    } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    var observed = document.body;
    if (observed && window.MutationObserver) {
      var obs = new MutationObserver(function (records) {
        if (records.some(function (r) {
          return Array.from(r.addedNodes).some(function (node) {
            return node.nodeType === 1 && !node.hasAttribute('data-bahari-cart-pin-warning') && (node.matches('.cart-item,.bahari-cart-item,.cart__footer-wrapper,.cart-drawer__items,.cart-drawer__footer,.cart-count-bubble') || (node.querySelector && !!node.querySelector('.cart-item,.bahari-cart-item,.cart-drawer__items')));
          }) || Array.from(r.removedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('.cart-item,.bahari-cart-item,.cart__footer-wrapper,.cart-drawer__items,.cart-drawer__footer') || (node.querySelector && !!node.querySelector('.cart-item,.bahari-cart-item'))); });
        })) schedule();
      });
      obs.observe(observed,{subtree:true,childList:true});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
